// exporting global window function here to greatly simplify testing
export const openInNewTab = window.open;
